import { Survey, SurveyQuestion } from 'types/survey';
import { Answer } from 'types/surveyResponse';
import { useSurveyTranslation } from 'hooks/useSurveyTranslation';
import { filterDependent } from 'utils/survey';
import { Radio } from 'components/ui/Radio';

interface IProps {
  surveyDefinition: Survey;
  question: SurveyQuestion;
  answer: Answer;
  siblingAnswers: Answer[];
  onChange: (answer: Answer) => void;
}

export const RadioQuestion = ({ surveyDefinition, question, answer, siblingAnswers, onChange }: IProps) => {
  const ts = useSurveyTranslation(surveyDefinition);

  return question.options
    ?.filter(o => filterDependent(o, siblingAnswers))
    .map((o) => (
    <Radio
      groupName={question.questionId}
      key={o.value}
      label={ts(o.name)}
      isChecked={answer.value === o.value}
      onSelect={() => onChange({ ...answer, value: o.value })}
    />
  ));
};
